import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenResolverService {

  constructor() {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TokenSupplier> | Promise<TokenSupplier> | TokenSupplier {
    let tokenUtilisateur: string = route.paramMap.get('tokenUtilisateur');

    let tokenSupplier = new TokenSupplier();

    tokenSupplier.token = tokenUtilisateur;

    return tokenSupplier;
  }
}

export class  TokenSupplier {
  token: string;
}
